import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ScrollSection } from '../components/ScrollSection';

function DonorsPartners() {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPartners();
  }, []);

  const fetchPartners = async () => {
    try {
      const response = await axios.get('/api/donors-partners');
      setPartners(response.data.donorsPartners || []);
    } catch (error) {
      console.error('Error fetching partners:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className="container-fluid page-header wow fadeIn"
        data-wow-delay="0.1s"
        style={{
          // background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(/img/carousel/admin2.jpg)',
          backgroundColor: '#0066cc',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="container text-center py-5 mt-4">
          <h1 className="display-2 text-white fw-bold mb-3 animated slideInDown" style={{ fontFamily: 'Georgia, serif' }}>
            Donors & Partners
          </h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb justify-content-center mb-0">
              <li className="breadcrumb-item fw-bold">
                <Link to="/" className="text-white">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item fw-bold text-white" aria-current="page">
                Donors & Partners
              </li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <div className="container py-5" style={{ maxWidth: '1200px', paddingLeft: '15px', paddingRight: '15px' }}>
        {/* Introductory Section */}
        <ScrollSection>
          <div style={{ marginBottom: '80px' }}>
            <h2 className="mb-4 text-center" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#0066cc', lineHeight: '1.2', fontFamily: 'Georgia, serif' }}>
              Donors & Partners
            </h2>
            <p className="text-center" style={{ fontSize: '1.1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
              We are grateful to our partners and donors who support our mission. Their contributions help us
              provide world-class healthcare services to our community.
            </p>
          </div>
        </ScrollSection>

        {/* Partners Grid */}
        <ScrollSection>
          <div>

            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : partners.length > 0 ? (
              <div className="row tgh-donors-partners-grid">
                {partners.map((partner) => (
                  <div key={partner.id} className="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-2">
                    <div className="tgh-partner-card h-100 d-flex align-items-center justify-content-center p-3" style={{
                      backgroundColor: '#fff',
                      borderRadius: '8px',
                      border: '1px solid #e0e0e0',
                      transition: 'all 0.3s ease',
                      cursor: partner.website ? 'pointer' : 'default',
                      minHeight: '150px',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                    }}
                    onMouseEnter={(e) => {
                      if (partner.website) {
                        e.currentTarget.style.transform = 'translateY(-5px)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                        e.currentTarget.style.borderColor = '#0066cc';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (partner.website) {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
                        e.currentTarget.style.borderColor = '#e0e0e0';
                      }
                    }}
                    >
                      {partner.website ? (
                        <a
                          href={partner.website}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-decoration-none d-block text-center w-100"
                          style={{ color: 'inherit' }}
                        >
                          <img
                            src={partner.image}
                            alt={partner.name}
                            className="img-fluid tgh-partner-logo mx-auto"
                            style={{ 
                              maxHeight: '120px', 
                              maxWidth: '100%',
                              objectFit: 'contain',
                              display: 'block'
                            }}
                            onError={(e) => {
                              e.target.src = '/img/Insurance.jpeg';
                            }}
                          />
                          {partner.name && (
                            <p className="mt-2 mb-0" style={{ fontSize: '0.9rem', color: '#666', fontWeight: '500' }}>
                              {partner.name}
                            </p>
                          )}
                        </a>
                      ) : (
                        <div className="text-center w-100">
                          <img
                            src={partner.image}
                            alt={partner.name}
                            className="img-fluid tgh-partner-logo mx-auto"
                            style={{ 
                              maxHeight: '120px', 
                              maxWidth: '100%',
                              objectFit: 'contain',
                              display: 'block'
                            }}
                            onError={(e) => {
                              e.target.src = '/img/Insurance.jpeg';
                            }}
                          />
                          {partner.name && (
                            <p className="mt-2 mb-0" style={{ fontSize: '0.9rem', color: '#666', fontWeight: '500' }}>
                              {partner.name}
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-5">
                <p style={{ fontSize: '1.1rem', color: '#666' }}>No donors/partners available at this time.</p>
              </div>
            )}
          </div>
        </ScrollSection>
      </div>
    </>
  );
}

export default DonorsPartners;
